import React from 'react';
import './style.scss';
import PropTypes from 'prop-types';

const GigCardShell = ({type, gigId, wrapperCls, children}) => {
    const classes = ['gig-card-base', 'slide', type, 'js-gig-card', 'js-slide'];
    wrapperCls && classes.push(wrapperCls);

    return (
        <div data-gig-id={gigId} className={classes.join(' ')}>
            {children}
        </div>
    );
};

GigCardShell.propTypes = {
    wrapperCls: PropTypes.string,
    gigId: PropTypes.number,
    type: PropTypes.string,
    children: PropTypes.any
};

export default GigCardShell;



// WEBPACK FOOTER //
// ./src/shared/card_shell/index.js